<template>
  <div class="content content-fixed">
    <div class="container">
      sdf
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
